export default () => ({
    root: {
        border: 'none',
        width: '100%',
        height: '100%',
    },
});
